import { createAsyncThunk } from '@reduxjs/toolkit';

import AiOnboardingController from '../controllers/AiOnboardingController';
import {
  IAiOnboardingDocumentContent,
  IAiOnboardingPharmacistLicenseVerificationResult,
  IUploadAiOnboardingDocumentParams,
  IVerifyAiOnboardingPharmacistLicenseParams,
} from '../models/AiOnboardingModels';
import { statusDispatch } from './globalActions';

const aiOnboardingPrefix = 'aiOnboarding';

export const aiOnboardingActions = {
  getWorkEthicsDocument:
    `${aiOnboardingPrefix}/get/work-ethics-document`,
  getOperationalBriefingDocument:
    `${aiOnboardingPrefix}/get/operational-briefing-document`,
  uploadDocument: `${aiOnboardingPrefix}/upload/document`,
  verifyPharmacistLicense:
    `${aiOnboardingPrefix}/verify/pharmacist-license`,
};

export const getAiOnboardingWorkEthicsDocument = createAsyncThunk<
IAiOnboardingDocumentContent
>(
  aiOnboardingActions.getWorkEthicsDocument,
  async (_, { rejectWithValue }) => {
    try {
      const response = await AiOnboardingController.getWorkEthicsDocument();
      return statusDispatch(
        response,
        rejectWithValue,
      ) as IAiOnboardingDocumentContent;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getAiOnboardingOperationalBriefingDocument = createAsyncThunk<
IAiOnboardingDocumentContent
>(
  aiOnboardingActions.getOperationalBriefingDocument,
  async (_, { rejectWithValue }) => {
    try {
      const response =
        await AiOnboardingController.getOperationalBriefingDocument();
      return statusDispatch(
        response,
        rejectWithValue,
      ) as IAiOnboardingDocumentContent;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const uploadAiOnboardingDocument = createAsyncThunk(
  aiOnboardingActions.uploadDocument,
  async (
    params: IUploadAiOnboardingDocumentParams,
    { rejectWithValue },
  ) => {
    try {
      const response = await AiOnboardingController.uploadDocument(params);
      return statusDispatch(response, rejectWithValue);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const verifyAiOnboardingPharmacistLicense = createAsyncThunk<
IAiOnboardingPharmacistLicenseVerificationResult,
IVerifyAiOnboardingPharmacistLicenseParams
>(
  aiOnboardingActions.verifyPharmacistLicense,
  async (
    params: IVerifyAiOnboardingPharmacistLicenseParams,
    { rejectWithValue },
  ) => {
    try {
      const response = await AiOnboardingController.verifyPharmacistLicense(
        params,
      );

      return statusDispatch(
        response,
        rejectWithValue,
      ) as IAiOnboardingPharmacistLicenseVerificationResult;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
